'use strict';
var anObject    = require('./_an-object')
  , toPrimitive = require('./_to-primitive')
  , NUMBER      = 'number';

module.exports = function(hint){
  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_date-to-primitive.js
 ** module id = 248
 ** module chunks = 0
 **/